import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  CategoryScale,
  BarElement,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Filler,
  LineController,
  BarController,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Filler,
  LineController,
  BarController,
  ChartDataLabels,
);
